import { FunctionComponent } from 'react';
import { useMount } from 'react-use';

import dayjs from 'dayjs';
import celendar from 'dayjs/plugin/calendar';
dayjs.extend(celendar);
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet';
import _ from 'lodash';
import { Link, useParams } from 'react-router-dom';
import { useGetPost, useConfig } from '~components/hooks';
import { PostContent, SidebarRight, Menu, ReadMore } from '~components/blog';
import { Loader } from '~components/Loader';
import NotFound from '../error/NotFound';
import { useYaMetrica } from '~frontend/provider/yametrica';

import '../../scss/pages/_news.scss';

import NewsBanner1 from '../../scss/images/news-banner.png';
import NewsBanner2 from '../../scss/images/news-banner-2.png';

const Post: FunctionComponent = () => {
  const getConfig = useConfig();
  const { id } = useParams();

  const { t } = useTranslation();

  const getPostApi = useGetPost({
    where: {
      id: _.toInteger(id),
    },
  });

  const { reachGoal } = useYaMetrica();

  useMount(() => {
    reachGoal('goPagePost');
  });

  if (getPostApi.loading) {
    return <Loader />;
  } else if (getPostApi.error) {
    return <>Post | Error! {getPostApi.error.message}</>;
  }

  const getPost = getPostApi?.data?.post;

  if (!getPost || getPost.status !== 'published') {
    return <NotFound />;
  }

  return (
    <>
      <Helmet>
        <title>{getPost?.title}</title>
        <meta name="description" content={getPost?.description} />
      </Helmet>
      <Menu />
      <div className="page-news">
        <div className="page-news-single">
          <aside className="page-single-sidebar">
            <span className="news-author">
              <img
                className="news-author-logo"
                src={`https://keystone.trustunboxing.com${getPost?.author?.avatar?.url}`}
                alt={getPost?.author?.name}
              />
              <span className="news-author-content">
                <span className="news-author-name">
                  {getPost?.author?.name}
                </span>
                <span className="news-author-date">
                  {dayjs(getPost?.publishDate).calendar()}
                </span>
              </span>
            </span>
            <div className="news-socials">
              {getConfig?.hostname !== 'cscase.com' && (
                <>
                  <a
                    className="tg"
                    href={getConfig?.seo.telegram}
                    rel="noopener noreferrer nofollow"
                    target="_blank"
                  ></a>
                  <a
                    className="vk"
                    href={getConfig?.seo.vk}
                    rel="noopener noreferrer nofollow"
                    target="_blank"
                  ></a>
                </>
              )}
              <a
                className="inst"
                href={getConfig?.seo.instagram}
                rel="noopener noreferrer nofollow"
                target="_blank"
              ></a>
              <a
                className="fb"
                href={getConfig?.seo.fb}
                rel="noopener noreferrer nofollow"
                target="_blank"
              ></a>
            </div>
            <div className="news-banners">
              <Link className="news-banner" to="/">
                <img src={NewsBanner1} width="166" height="272" />
                <span className="news-banner-title">
                  {t('cases')} cs:go!
                  <br />
                  {t('news-banner-title promo', {
                    percent: 15,
                    promoCode: 'blog',
                  })}
                </span>
              </Link>
              <Link className="news-banner news-banner-girl" to="/">
                <img src={NewsBanner2} width="166" height="268" />
                <span className="news-banner-title">
                  {t('cases')} cs:go!
                  <br />
                  {t('news-banner-title promo', {
                    percent: 15,
                    promoCode: 'blog',
                  })}
                </span>
              </Link>
            </div>
          </aside>
          <div className="page-news-wrapper">
            <section className="page-news-content">
              <div className="breadcrumbs">
                <Link to="/">cscase</Link>
                <Link to="/blog">{t('blog')}</Link>
                <Link to={`/blog/post/${getPost?.id}`}>{getPost?.title}</Link>
              </div>
              <h1>{getPost?.title}</h1>
              <img
                className="news-single-image"
                src={`https://keystone.trustunboxing.com${getPost?.background?.url}`}
                alt={getPost?.title}
              />
              <PostContent getPost={getPost} />
              <div className="news-single-btns">
                <Link to="/blog">{t('blog tag news')}</Link>
                <Link to="/blog/tag/case">{t('blog tag case')}</Link>
                <Link to="/case/free">{t('blog tag distributions')}</Link>
              </div>
            </section>
            <SidebarRight />
          </div>
        </div>
        <ReadMore />
      </div>
    </>
  );
};

export default Post;
